import { IxGenericTreeNode } from './IxGenericTreeNode.js';

window.customElements.define('ix-generic-tree-node', IxGenericTreeNode);
